export const firebaseErrors = {
  "auth/email-already-in-use": "This email has already been used",
  "auth/wrong-password": "The password you used is incorrect",
  "auth/unverified-email": "You must verify your email",
  "auth/weak-password": "The password you provided is not strong enough",
  "auth/user-not-found": "This email is not registered yet. Please sign-up.",
  "auth/email-not-found": "This email is not registered yet. Please sign-up.",
  "unknown": "Check your email and password",
};
